'use client';

import { LoadingPage } from '@/components/core/loading-page';
import { useAccountStatus } from '@/hooks/query/account';
import { useAuthData, useAuthToken } from '@/store/auth';
import { useColorSchemeStore } from '@/store/color-schema';

export const LoadingPageProvider = ({ children }: { children: React.ReactNode }) => {
	const { data: actStatus } = useAccountStatus();
	const authToken = useAuthToken();
	const { isRedisTokenChecked } = useAuthData() ?? {};
	const [isLoading] = useColorSchemeStore(state => [state.isLoading]);
	if (!isRedisTokenChecked || (isRedisTokenChecked && authToken && actStatus === undefined) || isLoading) {
		return <LoadingPage />;
	}

	return children;
}